import {
  getRowGroupingFieldFromGroupingCriteria,
  GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD,
} from "@mui/x-data-grid-premium";
import type { GroupingField, ReportField } from "../../../../../api/types/svTypes.ts";
import { DimensionFieldType } from "../../../../../api/types/svTypes.ts";

export const getTabularFieldGridId = (field: ReportField, grouping: GroupingField[], showGroupedColumns: boolean) => {
  if (field.type === DimensionFieldType.DIMENSION) {
    if (grouping.some((g) => g.id === field.config.guid)) {
      if (showGroupedColumns) {
        return getRowGroupingFieldFromGroupingCriteria(field.config.guid);
      }
      return GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD;
    }

    return field.config.guid;
  }
  if (
    field.type === DimensionFieldType.MEASURE ||
    field.type === DimensionFieldType.METRIC ||
    field.type === DimensionFieldType.CUSTOM
  ) {
    return field.config.guid;
  }
  return "";
};
